/** Configuração do app vinda do build (Vite). A URL da API nunca é fixa no código. */
const apiUrl = import.meta.env.VITE_API_URL;
if (!apiUrl) throw new Error('VITE_API_URL não definida no build do app.');

export const env = {
  apiUrl: apiUrl.replace(/\/+$/, ''),
  /**
   * Esquema do deep link do app Android (volta do SSO — T-028b). O mesmo do AndroidManifest e do
   * APP_DEEP_LINK_SCHEME da API; o build do Android o passa em VITE_APP_DEEP_LINK_SCHEME.
   */
  deepLinkScheme: import.meta.env.VITE_APP_DEEP_LINK_SCHEME || 'fluxusbsc',
} as const;
